import { call, put } from "redux-saga/effects";
import { SetHealthScreeningList } from "../../StateManagement/Reducers/HealthProfileState";
import { HealthScreeningListApi } from "../Apis/HealthScreeningApi";
import { Decrypt_Value } from "../EncryptDecrypt";

export function* HealthScreeningLists() {
  try {
    const res = yield call(HealthScreeningListApi);

    if (res.status === 200) {
      let decryptResponse = null;

      try {
        decryptResponse = Decrypt_Value(res.data, "vozo");
      } catch (err1) {
        console.log("Decrypt with vozo failed:", err1);

        try {
          decryptResponse = Decrypt_Value(res.data, "vozoportal");
        } catch (err2) {
          console.log("Decrypt with vozoportal failed:", err2);
          decryptResponse = null;
        }
      }

      if (typeof decryptResponse === "string" && decryptResponse !== "") {
        try {
          decryptResponse = JSON.parse(decryptResponse);
        } catch (err) {
          console.log("Health Screening decrypted parse failed:", err);
          decryptResponse = null;
        }
      }

      if (decryptResponse && decryptResponse.Status === "Success") {
        yield put(SetHealthScreeningList(decryptResponse.Data || []));
      } else {
        yield put(SetHealthScreeningList([]));
      }
    } else {
      yield put(SetHealthScreeningList([]));
    }
  } catch (e) {
    yield put(SetHealthScreeningList([]));
    console.log("Health Screening API error:", e);
  }
}
